
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Images Directory`}</h1>
    <p>{`You can add images in this folder, and reference them using`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import img from 'images/bild.jpg'

//...

<img src={img} />
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;